import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import $ from "jquery";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class PresaleRegister extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;


        this.state = {
            jwt: jwt,
            user_permission: user_permission,
            miss_su: helpers.getUserType(user_type, "su"),
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            userid: user_id,
            pages: [],
            page: 0,
            rowsPerPage: 10,
            add_id: "",
            add_member_name: "",
            add_member_email: "",
            add_member_phone: "",
            add_topic: "",
            add_detail: "",
            srcIsOpen: false,
            project_home: [],
            src_member_name: '',
            src_member_phone: '',
            src_member_email: '',
            src_topic: '',
            src_detail: '',
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.openView = this.openView.bind(this);
        this.closeAdd = this.closeAdd.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.change = this.change.bind(this);

        this.dataTable();
    }

    dataTable() {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/presale_contact?detail=' + this.state.src_detail
            + '&membername=' + this.state.src_member_name
            + '&email=' + this.state.src_member_email
            + '&topic=' + this.state.src_topic
            + '&phone=' + this.state.src_member_phone, requestOptions)
            .then(res => res.json())
            .then(data => {
                var DataFrom = data.data
                this.setState({
                    pages: [].concat(DataFrom)
                });
            }).catch(error => {
                console.log(error)
            });
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    openView(e) {

        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/presale_contact/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            .then(res => res.json())
            .then(dataSub => {
                var data = dataSub.data;
                
                this.setState({
                    add_id: data.id,
                    add_member_name: data.name,
                    add_member_email: data.email,
                    add_member_phone: data.telephone,
                    add_topic: data.topic,
                    add_detail: data.detail,
                    add_location: data.device_latitude + ", " + data.device_longitude,
                    add_os: data.device_type
                });
                console.log(data.project_name)
                this.setState({
                    addIsOpen: true,
                    methodOpen: 'view'
                });
            }).catch(error => {
                console.log(error)
                this.setState({
                    addIsOpen: false,
                });
            });
    }

    closeAdd() {
        this.setState({
            addIsOpen: false
        });
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_member_name: '',
            src_member_phone: '',
            src_member_email: '',
            src_topic: '',
            src_detail: '',
        });
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Contact Data List</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Contact Data</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="Contact Data" element={(this.state.user_permission[244].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="policytracking">
                                            <ExcelColumn label="หัวเรื่อง" value="topic" />
                                            <ExcelColumn label="รายละเอียด" value="detail" />
                                            <ExcelColumn label="ชื่อ" value="name" />
                                            <ExcelColumn label="อีเมล" value="email" />
                                            <ExcelColumn label="เบอร์โทร" value="telephone" />
                                            <ExcelColumn label="Location" value={(col) => `${col.device_latitude},${col.device_longitude}`} />
                                            <ExcelColumn label="OS" value="device_type" />
                                            <ExcelColumn label="วันเวลา" value={(col) => `${moment(col.created).format('DD/MM/YYYY H:mm น.')}`} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '80px' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หัวเรื่อง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อีเมล</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เบอร์โทร</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Location</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>OS</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันเวลา</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>การจัดการ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.topic}</StyledTableCell>
                                                                    <StyledTableCell>{data.name}</StyledTableCell>
                                                                    <StyledTableCell>{data.email}</StyledTableCell>
                                                                    <StyledTableCell>{data.telephone}</StyledTableCell>
                                                                    <StyledTableCell>{data.device_latitude + ", " + data.device_longitude}</StyledTableCell>
                                                                    <StyledTableCell>{data.device_type}</StyledTableCell>
                                                                    <StyledTableCell>{moment(data.created).format('DD/MM/YYYY H:mm น.')}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>ตรวจสอบข้อมูล</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อผู้ใช้</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_member_name}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">อีเมล</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_member_email}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทร</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_member_phone}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หัวเรื่อง</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_topic}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">รายละเอียด</div>
                                <div className="col-sm-5">
                                    <TextareaAutosize className="form-control" aria-label="minimum height" name="add_detail" rowsMin={1} defaultValue={this.state.add_detail} disabled />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Location</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_location}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">OS</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_os}</div>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อผู้ใช้</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_member_name" name="src_member_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">อีเมล</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_member_email" name="src_member_email" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทร</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_member_phone" name="src_member_phone" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หัวเรื่อง</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_topic" name="src_topic" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">รายละเอียด</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_detail" name="src_detail" onChange={this.change} />
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div><button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button></div>
                        <div><button className="btn btn-success" onClick={this.submitSrc}>ตกลง</button></div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}